import { countHabitsTowardLimit } from '@griply/utils';
import { useMemo } from 'react';
import { usePremiumFeatureAllowed } from 'shared/hooks/use-premium-feature-allowed';
import { LimitKeys } from 'shared/types/limit-keys';

import { useHabits } from './use-habits';

export const useCreateHabitAllowed = () => {
  const habits = useHabits({
    uncompletedOnly: true,
    unFrozenOnly: true,
    unArchivedOnly: true,
  });

  const total = useMemo(() => countHabitsTowardLimit(habits), [habits]);

  const { allowed, enforced, limit } = usePremiumFeatureAllowed(
    LimitKeys.CreateHabit,
    { total },
  );

  return { allowed, enforced, limit, total };
};
